import React, { useMemo } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";

import StyledScrollbar from "../../../Common/UIComponents/StyledScrollbar";
import StyledTooltip from "../../../Common/UIComponents/StyledTooltip";

import "./UsageMetricsTestActivityDetailModal.css";

const renderHeaderValue = (column, record) => {
  const value = record[column.dataIndex];
  if (column.render) return column.render(value, record);
  return value;
};

export default function UsageMetricsTestActivityDetailModal({
  open,
  record,
  columns,
  onClose,
  onAfterClose,
}) {
  const testColumns = useMemo(() => [
    {
      title: "Test Name",
      dataIndex: "test_name",
      key: "test_name",
      width: 160,
    },
    {
      title: "Sample ID",
      dataIndex: "sample_id",
      key: "sample_id",
      ellipsis: true,
      render: (sampleId) => (
        <StyledTooltip title={sampleId} placement="top">
          <span className="UsageMetricsTestActivityDetail__SampleId">{sampleId}</span>
        </StyledTooltip>
      ),
    },
    {
      title: "Side",
      dataIndex: "side",
      key: "side",
      width: 120,
    },
    {
      title: "Tests",
      dataIndex: "tests",
      key: "tests",
      width: 110,
      render: (tests) => {
        const amount = Number(tests);
        let className = "";
        if (amount > 0) className = "UsageMetricsTestActivity__Tests--positive";
        if (amount < 0) className = "UsageMetricsTestActivity__Tests--negative";
        return <span className={className}>{tests}</span>;
      },
    },
    {
      title: "Usage Category",
      dataIndex: "usage_category_name",
      key: "usage_category_name",
      width: 200,
    },
  ], []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      afterClose={onAfterClose}
      footer={null}
      closable={false}
      width={960}
      centered
      destroyOnHidden
      className="UsageMetricsTestActivityDetail"
    >
      <header className="UsageMetricsTestActivityDetail__TitleBar">
        <h2>Activity Details</h2>
        <Button
          type="text"
          icon={<CloseOutlined />}
          className="UsageMetricsTestActivityDetail__CloseButton"
          onClick={onClose}
          aria-label="Close activity details"
        />
      </header>

      {record && (
        <>
          <div className="UsageMetricsTestActivityDetail__Summary">
            {columns.map((column) => (
              <div key={column.key} className="UsageMetricsTestActivityDetail__Field">
                <span className="UsageMetricsTestActivityDetail__FieldLabel">{`${column.title}:`}</span>
                <span className="UsageMetricsTestActivityDetail__FieldValue">
                  {renderHeaderValue(column, record)}
                </span>
              </div>
            ))}
          </div>

          <div className="UsageMetricsTestActivityDetail__Tests">
            <h3 className="UsageMetricsTestActivityDetail__TestsTitle">Tests</h3>
            <div className="UsageMetricsTestActivityDetail__TableWrap">
              <StyledScrollbar
                className="UsageMetricsTestActivityDetail__ScrollBar"
                noScrollX
                disableTrackYWidthCompensation
                disableTracksWidthCompensation
              >
                <Table
                  className="UsageMetricsTestActivityDetail__Table"
                  rowKey={(test, index) => `${test.sample_unique_identifier}|${test.test_name}|${index}`}
                  columns={testColumns}
                  dataSource={record.testItems}
                  pagination={false}
                />
              </StyledScrollbar>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
}
